/* Pure Cartel — cart page: live line-item updates via the real Shopify Ajax Cart API */
(function () {
  "use strict";

  var page = document.getElementById("cartPage");
  if (!page) return;

  var itemsWrap = document.getElementById("cartItems");

  function refreshSection() {
    var url = window.location.pathname + "?section_id=main";
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var freshMain = doc.getElementById("cartPage");
        if (freshMain) page.innerHTML = freshMain.innerHTML;
        return window.PureCartel && window.PureCartel.refreshCart && window.PureCartel.refreshCart();
      });
  }

  page.addEventListener("click", function (e) {
    var btn = e.target.closest("button[data-act]");
    if (!btn) return;
    var line = Number(btn.dataset.line);
    var act = btn.dataset.act;

    if (act === "remove") {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(refreshSection);
      return;
    }

    var qtyEl = btn.closest(".cart-item__controls").querySelector(".qty span");
    var current = parseInt(qtyEl.textContent, 10) || 0;
    var next = act === "plus" ? current + 1 : Math.max(0, current - 1);
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: next })
    }).then(refreshSection);
  });
})();
